import * as MUIIcon from "react-icons/md";

import { FetchRequestTime } from "./FetchRequestTime";
import { Icon } from "../../Icon";
import React from "react";
import { ActionButton } from "./ActionButton";
import { TUserRole } from "configs/routes";
import { Permission } from "components/Permission";

export type TActionButton = {
  iconName: keyof typeof MUIIcon;
  showLoading?: boolean;
  buttonTooltip?: string;
  action: () => void;
  id?: string;
  permissions?: TUserRole[];
};

type TTableActionsContainer = {
  refetch?: () => void;
  refetchButtonId?: string;
  requestTime: number;
  isLoading?: boolean;
  showDpPanelServerTime?: boolean;
  showRequestTime?: boolean;
  actionButtons?: TActionButton[];
} & React.PropsWithChildren;
export default function ActionsBar({
  children,
  refetch,
  refetchButtonId,
  requestTime,
  isLoading = false,
  actionButtons,
  showDpPanelServerTime,
  showRequestTime = true,
}: TTableActionsContainer) {
  return (
    <div className="flex flex-col items-end gap-3">
      <div className="flex items-center h-10 justify-end">
        {(actionButtons || children) && (
          <div className="flex flex-row items-center h-full bg-primary-90 rounded-s-full pr-1">
            {children && children}
            {actionButtons?.map((item, index) => {
              return (
                <Permission allowed={item?.permissions || []}>
                  <ActionButton
                    iconName={item.iconName}
                    buttonTooltip={item.buttonTooltip || ""}
                    action={item.action}
                    showLoading={item.showLoading}
                    {...(item?.id && { id: item.id })}
                    key={index}
                  />
                </Permission>
              );
            })}
          </div>
        )}
        {/*<div className="flex h-full rounded-s-full overflow-hidden bg-mofidNeutral-40">*/}
        {/*  <div className="h-full w-10 flex justify-center items-center  bg-mofidNeutral-40 rounded-e-full cursor-pointer hover:bg-mofidNeutral-40 hover:!text-mofidGray-white ">*/}
        {/*    {isLoading ? (*/}
        {/*      <CircularProgress*/}
        {/*        size={18}*/}
        {/*        color="inherit"*/}
        {/*        className="text-mofidBlue-80"*/}
        {/*      />*/}
        {/*    ) : (*/}
        {/*      <Tooltip title={"تازه سازی داده"} placement="bottom">*/}
        {/*        <IconButton*/}
        {/*          onClick={refetch}*/}
        {/*          {...(refetchButtonId && { id: refetchButtonId })}*/}
        {/*        >*/}
        {/*          <Icon*/}
        {/*            icon="MdReplay"*/}
        {/*            className="text-mofidGray-130"*/}
        {/*            fontSize="1.35rem"*/}
        {/*          />*/}
        {/*        </IconButton>*/}
        {/*      </Tooltip>*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*  {showRequestTime && (*/}
        {/*    <div className="flex flex-col h-full justify-between py-1 pr-1 pl-2">*/}
        {/*      <LastUpdateIndicator />*/}
        {/*      <FetchRequestTime requestTime={requestTime} />*/}
        {/*    </div>*/}
        {/*  )}*/}
        {/*</div>*/}
      </div>
    </div>
  );
}
